import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";

const Navbar = () => {
  const [click, setclick] = useState(false);
  const handleClick = () => setclick(!click);

  const [color, setColor] = useState(false);
  const changeColor = () => {
    if (window.scrollY >= 180) {
      //if scroll >= 1px
      setColor(true);
    } else {
      setColor(false);
    }
  };

  window.addEventListener("scroll", changeColor);

  return (
    <>
      <div className={color ? "header header-bg" : "header"} id="top">
        <Link to="/">
          <div className="logo">
            <i class="fa-solid fa-beer-mug-empty fa-flip-horizontal icon"></i>
            <p className="logo-title">cktails</p>
          </div>
        </Link>
        <i class="fa-solid fa-bars fa-fade bars" onClick={handleClick}></i>
        <ul className={click ? "nav-menu active" : "nav-menu"}>
          <li>
            <i class="fa-solid fa-xmark xmark" onClick={handleClick}></i>
          </li>
          <li>
            <NavLink to="/">Home</NavLink>
          </li>
          <li>
            <NavLink to="/about">About</NavLink>
          </li>
          <li>
            <NavLink to="/cocktails">Cocktails</NavLink>
          </li>
          <li>
            <NavLink to="/favorites">Favorites</NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
